import { FC, useContext, useEffect } from "react";

import { PUBSUB_VIRTUAL_CLASS_STATE_MESSAGE_TYPE } from "../../shared/types/av-state";

import { SectionInfo } from "./SectionInfo";
import { SectionStats } from "./SectionStats";
import { UserStats } from "./UserStats";

import { serverGetMonitoringStats } from "api/api-monitoring";
import { PubsubWebsocketContext } from "providers/PubsubWebsocketProvider";
import { useAppDispatch, useAppSelector } from "store/index";
import { selectCurrentSectionId } from "store/selectors";
import { selectClassStateLastUpdatedAt } from "store/selectors/pubsub-virtual-class-state";
import { monitoringStateActions } from "store/slices/monitoring";

export const SectionMonitoringDashboard: FC = () => {
  const dispatch = useAppDispatch();
  const sectionId = useAppSelector(selectCurrentSectionId);

  const { sendPubsubMessage, pubsubStatus } = useContext(PubsubWebsocketContext);

  const hasReceivedClassState = useAppSelector(selectClassStateLastUpdatedAt) !== null;

  useEffect(() => {
    if (hasReceivedClassState || pubsubStatus !== "connected") return;
    //  Request the current state for monitoring
    sendPubsubMessage({
      type: PUBSUB_VIRTUAL_CLASS_STATE_MESSAGE_TYPE,
      action: "join",
      force: false,
      virtual_user_id: `monitoring`,
    });
  }, [hasReceivedClassState, sendPubsubMessage, pubsubStatus]);

  useEffect(() => {
    if (!sectionId) return;
    const fetchMonitoringStats = async () => {
      const stats = await serverGetMonitoringStats(sectionId);
      dispatch(monitoringStateActions.setMonitoringStats(stats));
    };
    fetchMonitoringStats();
  }, [sectionId, dispatch]);

  return (
    <div className="flex h-screen flex-col overflow-hidden">
      <div className="w-full flex-shrink-0 bg-blue p-4">
        <h1 className="text-center text-white">ForumV Monitoring Dashboard</h1>
      </div>
      <div className="flex-1 overflow-y-auto p-8">
        <div className="flex flex-col gap-8">
          <div>
            <h1 className="h2">Course Info</h1>
            <SectionInfo />
          </div>
          <div>
            <h1 className="h2">Course Stats</h1>
            <SectionStats />
          </div>
          <div>
            <h1 className="h2">User Stats</h1>
            <UserStats />
          </div>
        </div>
      </div>
    </div>
  );
};
